// Servicio para cargar diagramas de forma segura desde src/
// Los archivos .md están bundleados con la aplicación y no son accesibles directamente por URL

import { diagramCategories } from '../data/diagrams.js';

// ============================================================================
// CONSTRUCCIÓN AUTOMÁTICA DEL MAPA DE DIAGRAMAS
// ============================================================================
// Este mapa se construye automáticamente desde la configuración en diagrams.js
// Ya no necesitas modificar este archivo cuando agregues nuevos diagramas

// Función auxiliar para construir el mapa de diagramas desde la configuración
const buildDiagramMap = () => {
  const map = {};

  diagramCategories.forEach(category => {
    if (category.subcategories) {
      category.subcategories.forEach(subcategory => {
        subcategory.diagrams.forEach(diagram => {
          if (diagram.file) {
            map[diagram.id] = diagram.file;
          }
        });
      });
    } else if (category.diagrams) {
      category.diagrams.forEach(diagram => {
        if (diagram.file) {
          map[diagram.id] = diagram.file;
        }
      });
    }
  });

  return map;
};

// Mapa de diagramas construido automáticamente
const diagramMap = buildDiagramMap();

/**
 * Carga el contenido de un diagrama de forma segura
 * Solo funciona si el usuario está autenticado y accede a través del componente
 *
 * @param {string} diagramId - ID del diagrama a cargar
 * @returns {Promise<string>} - Contenido del archivo markdown
 * @throws {Error} - Si el diagrama no existe
 */
export const loadDiagramContent = async (diagramId) => {
  const diagramPath = diagramMap[diagramId];

  if (!diagramPath) {
    throw new Error(`Diagrama no encontrado: ${diagramId}`);
  }

  try {
    // Fetch del módulo importado (Webpack/CRA lo convierte en una URL interna)
    const response = await fetch(diagramPath);

    if (!response.ok) {
      throw new Error('No se pudo cargar el archivo');
    }

    return await response.text();
  } catch (error) {
    console.error(`Error cargando diagrama ${diagramId}:`, error);
    throw error;
  }
};

/**
 * Verifica si un diagrama existe
 *
 * @param {string} diagramId - ID del diagrama
 * @returns {boolean} - true si el diagrama existe
 */
export const diagramExists = (diagramId) => {
  return diagramId in diagramMap;
};

/**
 * Obtiene la lista de IDs de diagramas disponibles
 *
 * @returns {string[]} - Array de IDs de diagramas
 */
export const getAvailableDiagramIds = () => {
  return Object.keys(diagramMap);
};
